import * as types from './mutation-types'

export default {
    [types.LOAD_CHECKOUT_STATUS](state, data) {
        state.checkoutStatus = data
    }
}
